import { keyframes } from '@emotion/react';

const shakeAnimation = (duration?: number) => {
  const animKeyframes = keyframes`
  0% { transform: translateX(0) }
  15% { transform: translateX(0.1em) }
  30% { transform: translateX(-0.15em) }
  45% { transform: translateX(0.2em) }
  60% { transform: translateX(-0.2em) }
  75% { transform: translateX(0.15em) }
  90% { transform: translateX(-0.1em) }
  100% { transform: translateX(0) }`;

  return `${animKeyframes} ${duration ?? 500}ms linear`;
};

const fadeInScaleAnimation = (duration?: number, delay?: number) => {
  const animKeyframes = keyframes`
  0% { opacity: 0; transform: scale(0.9) }
  90% { transform: scale(1.01) }
  100% { opacity: 1; transform: scale(1) }`;
  return `${animKeyframes} ${duration ?? 200}ms ease ${delay ?? 0}ms`;
};

const fadeInScalePopAnimation = (duration?: number, delay?: number) => {
  const animKeyframes = keyframes`
  0% { opacity: 0; transform: scale(0.9) }
  40% { opacity: 1; transform: scale(1.3) }
  80% { transform: scale(1.3) }
  100% { opacity: 1; transform: scale(1) }`;
  return `${animKeyframes} ${duration ?? 400}ms ease ${delay ?? 0}ms`;
};

const fadeInAnimation = (duration?: number) => {
  const animKeyframes = keyframes`
  0% { opacity: 0 }
  100% { opacity: 1 }`;
  return `${animKeyframes} ${duration ?? 200}ms linear`;
};

const fadeInLeftAnimation = (duration?: number, delay?: number) => {
  const animKeyframes = keyframes`
  0% { opacity: 0; transform: translateX(-1em) }
  100% { opacity: 1; transform: translateX(0) };`;
  return `${animKeyframes} ${duration ?? 200}ms ease ${delay ?? 0}ms`;
};
const fadeInRightAnimation = (duration?: number, delay?: number) => {
  const animKeyframes = keyframes`
  0% { opacity: 0; transform: translateX(1em) }
  100% { opacity: 1; transform: translateX(0) };`;
  return `${animKeyframes} ${duration ?? 200}ms ease ${delay ?? 0}ms`;
};
const fadeInBottomAnimation = (duration?: number, delay?: number) => {
  const animKeyframes = keyframes`
  0% { opacity: 0; transform: translateY(1em) }
  100% { opacity: 1; transform: translateY(0) };`;
  return `${animKeyframes} ${duration ?? 200}ms ease ${delay ?? 0}ms`;
};

const scaleInWidthAnimation = (
  toWidth: string,
  duration?: number,
  delay?: number,
) => {
  const animKeyframes = keyframes`
  0% { max-width: 0 }
  100% { max-width: ${toWidth} };`;
  return `${animKeyframes} ${duration ?? 200}ms ease ${
    delay ?? 0
  }ms 1 normal both`;
};
const scaleInHeightAnimation = (
  toHeight: string,
  duration?: number,
  delay?: number,
) => {
  const animKeyframes = keyframes`
  0% { max-height: 0; opacity: 0 }
  100% { max-height: ${toHeight}; opacity: 1 };`;
  return `${animKeyframes} ${duration ?? 200}ms ease ${
    delay ?? 0
  }ms 1 normal both`;
};

const fadeInOutAnimation = (duration: number) => {
  const animKeyframes = keyframes`
  0% { opacity: 0 }
  10% { opacity: 1 }
  90% { opacity: 1 }
  100% { opacity: 0 }`;
  return `${animKeyframes} ${duration}ms linear`;
};

const scaleInAnimation = (duration?: number) => {
  const animKeyframes = keyframes`
  0% { transform: scale(0) }
  100% { transform: scale(1) };`;
  return `${animKeyframes} ${duration ?? 200}ms ease`;
};

const stretchAnimation = () => {
  const animKeyframes = keyframes`
  0% {
    -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
  }
  7% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
            transform: scale3d(1.25, 0.75, 1);
  }
  10% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
            transform: scale3d(0.75, 1.25, 1);
  }
  13% {
    -webkit-transform: scale3d(1.15, 0.85, 1);
            transform: scale3d(1.15, 0.85, 1);
  }
  20% {
    -webkit-transform: scale3d(.95, 1.05, 1);
            transform: scale3d(.95, 1.05, 1);
  }
  25% {
    -webkit-transform: scale3d(1.05, .95, 1);
            transform: scale3d(1.05, .95, 1);
  }
  30% {
    -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
  }`;
  return `${animKeyframes} 4000ms ease infinite`;
};

const constantRotation = (speed?: number) => {
  const animKeyframes = keyframes`
  0% { transform: rotate(0) }
  100% { transform: rotate(360deg) };`;
  return `${animKeyframes} ${speed ?? 5000}ms linear infinite`;
};
const blinkAnimation = () => {
  const animKeyframes = keyframes`
  0% { opacity: 1 }
  50% { opacity: 0.5 }
  100% { opacity: 1`;
  return `${animKeyframes} 1.5s linear infinite`;
};
const moveRightLeftAnimation = (duration?: number, delay?: number) => {
  const animKeyframes = keyframes`
  0% { opacity: 1; transform: translateX(0) }
  50% { opacity: 0.9; transform: translateX(0.5em) }
  100% { opacity: 1; transform: translateX(0) };`;
  return `${animKeyframes} ${duration ?? 1200}ms ease ${delay ?? 0}ms infinite`;
};
const moveDownUpAnimation = (duration?: number, delay?: number) => {
  const animKeyframes = keyframes`
  0% { opacity: 1; transform: translateY(0) }
  50% { opacity: 0.9; transform: translateY(0.5em) }
  100% { opacity: 1; transform: translateY(0) };`;
  return `${animKeyframes} ${duration ?? 1200}ms ease ${delay ?? 0}ms infinite`;
};
const changeColorsAnimation = (duration?: number, delay?: number) => {
  const animKeyframes = keyframes`
  0% { color: #f2902e }
  25% { color: #45f22e }
  50% { color: #2ef2e8 }
  75% { color: #a42ef2 }
  100% { color: #f2902e };`;
  return `${animKeyframes} ${duration ?? 2000}ms linear ${
    delay ?? 0
  }ms infinite`;
};
const moveDownRotateAnimation = (duration?: number, delay?: number) => {
  const animKeyframes = keyframes`
  0% { opacity: 0; transform: matrix(0.91,-0.41,0.41,0.91,-12,-12) }
  80% { opacity: 1; transform: matrix(0.95,0.31,-0.31,0.95,0,4) }
  100% { opacity: 1; transform: matrix(1.00,0.00,0.00,1.00,0,0) };`;
  return `${animKeyframes} ${duration ?? 1400}ms ease ${delay ?? 0}ms`;
};

const pulseAnimation = (colorHex: string, duration?: number) => {
  const animKeyframes = keyframes(`
    0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 ${colorHex}B3;
    }

    40% {
        transform: scale(1.1);
        box-shadow: 0 0 0 10px ${colorHex}00;
    }

    60% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 ${colorHex}00;
    }`);
  return `${animKeyframes} ${duration ?? 2000}ms linear 0ms infinite`;
};

const pulseWithoutScaleAnimation = (colorHex: string, duration?: number) => {
  const animKeyframes = keyframes(`
    0% {
        box-shadow: 0 0 0 0 ${colorHex}B3;
    }

    40% {
        box-shadow: 0 0 0 10px ${colorHex}00;
    }

    60% {
        box-shadow: 0 0 0 0 ${colorHex}00;
    }`);
  return `${animKeyframes} ${duration ?? 2000}ms linear 0ms infinite`;
};

const fadeInTopAnimation = (duration?: number, delay?: number) => {
  const animKeyframes = keyframes`
  0% { opacity: 0; transform: translateY(-1em) }
  100% { opacity: 1; transform: translateY(0) };`;
  return `${animKeyframes} ${duration ?? 200}ms ease ${delay ?? 0}ms`;
};

export {
  pulseAnimation,
  constantRotation,
  shakeAnimation,
  fadeInAnimation,
  fadeInLeftAnimation,
  fadeInOutAnimation,
  fadeInScaleAnimation,
  scaleInWidthAnimation,
  scaleInHeightAnimation,
  stretchAnimation,
  scaleInAnimation,
  blinkAnimation,
  fadeInRightAnimation,
  fadeInScalePopAnimation,
  fadeInBottomAnimation,
  moveRightLeftAnimation,
  moveDownUpAnimation,
  changeColorsAnimation,
  moveDownRotateAnimation,
  pulseWithoutScaleAnimation,
  fadeInTopAnimation,
};
